module.exports = __webpack_public_path__ + "img/img1_1.5d2e64f6.png";